import * as App from 'firebase/app';
import * as Auth from 'firebase/auth';
import * as Fire from 'firebase/firestore';
import * as Funcs from 'firebase/functions';
import * as Storage from 'firebase/storage';

const config = {
  apiKey: process.env.SNOWIT_FIREBASE_API_KEY,
  appId: process.env.SNOWIT_FIREBASE_APP_ID,
  authDomain: process.env.SNOWIT_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.SNOWIT_FIREBASE_DATABASE_URL,
  // measurementId: process.env.SNOWIT_FIREBASE_MEASUREMENT_ID, // WARN: rimosso perchè è lo stesso GA4 id che usiamo su analytics :facepalm
  messagingSenderId: process.env.SNOWIT_FIREBASE_MESSAGING_ID,
  projectId: process.env.SNOWIT_FIREBASE_PROJECT_ID,
  storageBucket: process.env.SNOWIT_FIREBASE_BUCKET,
};

export const app = App.initializeApp(config);
export const storage = Storage.getStorage(app);
export const auth = Auth.getAuth(app);
export const db = Fire.getFirestore(app);
export const dbLogs = Fire.getFirestore(app, 'logs');
export const functions = Funcs.getFunctions(
  app,
  process.env.SNOWIT_ENV === 'local' || process.env.SNOWIT_ENV === 'emulator'
    ? 'us-central1'
    : 'europe-west1',
);

if (process.env.SNOWIT_ENV === 'emulator') {
  Auth.connectAuthEmulator(auth, 'http://localhost:9099');
  Fire.connectFirestoreEmulator(db, 'localhost', 5002);
  Funcs.connectFunctionsEmulator(functions, 'localhost', 5001);
  Storage.connectStorageEmulator(storage, 'localhost', 9199);
}

if (process.env.SNOWIT_ENV === 'local') {
  Funcs.connectFunctionsEmulator(functions, 'localhost', 5001);
}
